import { render, staticRenderFns } from "./PolicyInput.vue?vue&type=template&id=e4bc9848&scoped=true"
import script from "./PolicyInput.vue?vue&type=script&lang=js"
export * from "./PolicyInput.vue?vue&type=script&lang=js"
import style0 from "./PolicyInput.vue?vue&type=style&index=0&id=e4bc9848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bc9848",
  null
  
)

export default component.exports